import { cva } from 'class-variance-authority';

export const resourceCardStyle = cva(
  'border-cardBorder group flex w-full flex-col gap-3 rounded-lg border-[1.5px] border-solid border-primary-300 p-3 ',
  {
    variants: {
      isDark: {
        true: 'bg-resourceCardGradient-dark',
        false: 'bg-primary-50',
      },
      isDarkGradient: {
        true: 'bg-resourceCardGradient-dark',
        false: 'bg-primary-50',
      },
    },
  },
);
